/**
 * Route for `advertiser-widgets`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserWidgetsPage } from "../features/advertiser-widgets/AdvertiserWidgetsPage";

export const advertiserWidgetsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-widgets",
	component: AdvertiserWidgetsPage,
});

export default advertiserWidgetsRoute;
